import React from "react";
import Datepicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Style from "./datepicker.module.scss";
import PropTypes from "prop-types";
import { dashboard } from "../../locales/en";
import { dMMMyyyy } from "../../utils/constants/appConstants";
import { isWeekendNZT, getMinRepaymentDate } from "../../utils/utils";

const RepayDatePickerV1 = ({ value, onChange, disabled }) => {
  const handleKeyDown = (e) => {
    e.preventDefault();
  };

  const filterDate = (date) => {
    return !isWeekendNZT(date);
  };

  return (
    <Datepicker
      className={Style.datepicercustom}
      selected={value}
      onChange={(date) => onChange(date)}
      dateFormat={dMMMyyyy}
      placeholderText={dashboard.invoiceDatatable.repayDate}
      minDate={getMinRepaymentDate()}
      onKeyDown={handleKeyDown}
      filterDate={filterDate}
      autoComplete="off"
      disabled={disabled}
    />
  );
};

RepayDatePickerV1.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default RepayDatePickerV1;
